var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadAutomation4P = function SvgFadAutomation4P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 74)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 32,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 128)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 32,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 48)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 32,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(118 145)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 32,
    r: 16
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.123 129.952 81.225 99.73l13.254 10.094-16.276 28.678zm96.821 17.865L175.584 127l14.592 8.271-15.455 22.721zM108.34 111 130 154.063 144.531 146l-21.525-42.285z"
  }))));
};
export { SvgFadAutomation4P as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-automation-4p.0520a0b4.svg";